import { ADD_ON_COMPATIBILITY_API } from 'constants/AppConstants';

export default async (wallsProductId, wallsAddOnProductId) => {
  try {
    const response = await fetch(`${ADD_ON_COMPATIBILITY_API}?wallsProductId=${wallsProductId}&wallsAddOnProductId=${wallsAddOnProductId}`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
